export default __webpack_public_path__ + "static/media/454.409146c4.png";